import { defineComponent as _defineComponent } from 'vue';
import { defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'Logo20Component',
  setup: function setup(__props) {
    defineComponent({
      name: 'Logo20Component'
    });
    return {
      __sfc: true
    };
  }
});